import axios from '../../../axiosClient.js';

export default async function fetchTzmmsActivity(year) {
  const response = await axios.get('/api/tzmms-activity', {
    params: year ? { year } : undefined,
  });

  return response.data;
}
